import UploadBlueprint from './UploadBlueprint.component';

export default UploadBlueprint;
